import type { Direction, PrimaryColor } from "../styles/theme/types";

// Re-export theme types for convenience
export type { Direction, PrimaryColor } from "../styles/theme/types";

export interface BrandSettings {
	logo?: {
		url: string;
		fileName: string;
		size: number;
	};
	colors?: {
		primary?: string;
	};
	theme?: string;
	mapSettings?: {
		highlightColor?: string;
		highlightOpacity?: number; // 0-100
	};
}

export interface LocalisationSettings {
	localisationEnabled: boolean;
	overridesByLocale: Record<string, Record<string, string>>;
}

export const CUSTOM_LOCALE = "mango:custom";

export const DEFAULT_LOCALISATION_SETTINGS: LocalisationSettings = {
	localisationEnabled: false,
	overridesByLocale: {
		[CUSTOM_LOCALE]: {},
	},
};

export interface DomainSettings {
	customDomainEnabled?: boolean;
	customDomain?: string;
	dnsConfigured?: boolean;
}

export interface WhitelabelSettings {
	removeBranding?: boolean;
}

export interface Settings {
	direction?: Direction;
	primaryColor?: PrimaryColor;
	brand?: BrandSettings;
	localisation?: LocalisationSettings;
	domain?: DomainSettings;
	whitelabel?: WhitelabelSettings;
}
